// src/firebase.js

import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// --- Inisialisasi Firebase - FINAL & BENAR UNTUK SEMUA LINGKUNGAN ---
// Kunci API Anda ditulis langsung di sini untuk memastikan aplikasi selalu bisa terhubung.
const firebaseConfig = {
    apiKey: "AIzaSyBxF6VHS7oAqFrnTkdWtyPvc2tJnQI17i8",
    authDomain: "semesta-app-dcff6.firebaseapp.com",
    projectId: "semesta-app-dcff6",
    storageBucket: "semesta-app-dcff6.appspot.com",
    messagingSenderId: "147343991951",
    appId: "1:147343991951:web:6acf2213d28821368ebcfa"
};

// Inisialisasi Firebase
export const app = initializeApp(firebaseConfig);

// Ekspor instance yang sudah diinisialisasi untuk digunakan di seluruh aplikasi
export const db = getFirestore(app);
export const auth = getAuth(app);
export const appId = firebaseConfig.projectId;
